<div class="h-full w-full" *ngIf="formElements?.length && checklistFormGroup">
  <form [formGroup]="checklistFormGroup">
    <div class="sm:rounded-2xl pb-20">
      <div class="bg-white grid grid-cols-3 px-6 gap-x-3">
        <div class="flex flex-col" *ngFor="let element of formElements;let i=index"
        [ngClass]="element.width || 'col-span-3'"
        >
        <ng-container  *ngIf="element['showFieldBasedOnDependency']">
          <div class="flex items-center mt-3" *ngIf="element['showFieldBasedOnDependency'] && element?.field_type !== 'HEADER'">
            <label for="{{element?.field_name +'_'+ i}}" class="block text-base font-medium mb-1 text-gray-700 inline-flex items-center" [ngClass]="{'required': element?.is_required }">{{element?.field_name}}</label>
            <span class="inline-flex items-center" *ngIf="element?.field_description"><em [matTooltip]="element?.field_description" class="text-lg mb-1.5 ml-2 text-primary cursor-pointer ti ti-info-circle"></em></span>      
          </div> 
          <div class="w-full mb-4" *ngIf="element?.field_type === 'HEADER' && element['showFieldBasedOnDependency']" >
            <div *ngIf="i!==0" class="border-dashed border border-gray-300 mb-4"></div>
            <div class="flex items-center px-6 sm:px-0" [ngClass]="{'mt-4':i===0}">
              <h3 class="text-lg font-medium leading-6 text-gray-900">{{element?.field_name}}</h3>
              <span class="inline-flex items-center" *ngIf="element?.field_description"><em [matTooltip]="element?.field_description" class="text-lg ml-2 text-primary cursor-pointer ti ti-info-circle"></em></span>
            </div>
          </div>
            <!-- Text Input -->
            <div class="w-full mb-4" *ngIf="['SINGLE_LINE','BARCODE'].includes(element?.field_type) && element['showFieldBasedOnDependency']">
              <div *ngIf="element?.original_template?.field_validation === 'number' && element['showFieldBasedOnDependency']">
                <input 
                  type="number" 
                  name="{{element?.field_name +'_'+ i}}" 
                  id="{{element?.field_name +'_'+ i}}" 
                  max="{{element?.max_value}}"
                  min="{{element?.min_value}}"
                  [formControlName]="element?.formControlName"
                  class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base">
                  
              </div>
              <div *ngIf="element?.original_template?.field_validation !== 'number' && element['showFieldBasedOnDependency']">
                <input 
                  type="text" 
                  name="{{element?.field_name +'_'+ i}}" 
                  id="{{element?.field_name +'_'+ i}}"
                  pattern="{{element?.regex_value}}" 
                  class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base"
                  placeholder="{{element?.field_placeholder}}"
                  [formControlName]="element?.formControlName">
              </div>
            </div>
  
            <!-- Time Input -->
            <div class="w-full mb-4" *ngIf="element?.field_type === 'TIME' && Object.keys(timePickerModel).length > 0 && element['showFieldBasedOnDependency']">
              <input 
                    [matMenuTriggerFor]="newMenu"
                    type="text" 
                    name="{{element?.field_name +'_'+ i}}" 
                    id="{{element?.field_name +'_'+ i}}"
                    [formControlName]="element?.formControlName"
                    class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base cursor-pointer"
                    placeholder="{{element?.field_placeholder}}"
                  >
                <mat-menu #newMenu="matMenu">
                    <div class="flex flex-col">
                        <div class="flex justify-center">
                        <ngx-mat-timepicker #timePicker (click)="$event.stopPropagation();"
                        [showSpinners]="true"
                        [stepHour]="1" [stepMinute]="15"
                        [showSeconds]="false"
                        [enableMeridian]="true"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="timePickerModel[element?.field_name]"
                        (ngModelChange)="setTimeFormControl(element?.field_name)"
                        >
                        </ngx-mat-timepicker>
                        </div>
                    </div>
                </mat-menu>
            </div>
  
            <!-- Text Area -->
            <div class="w-full mb-4" *ngIf="element?.field_type === 'MULTI_LINE' && element['showFieldBasedOnDependency']">
              <textarea 
                  type="text" 
                  name="{{element?.field_name +'_'+ i}}" 
                  id="{{element?.field_name +'_'+ i}}" 
                  class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base"
                  placeholder="{{element?.field_placeholder}}"
                  [formControlName]="element?.formControlName"
              ></textarea>
            </div>
  
            <div class="w-full mb-4" *ngIf="element?.field_type === 'MULTI_ITEM' && element['showFieldBasedOnDependency']">
              <div class="relative flex items-start mt-2" *ngFor="let checkboxData of element?.field_options;let j=index" [ngClass]="{'pointer-events-none cursor-default': previewForm}">
                <div class="flex h-5 items-center">
                  <input id="{{element?.field_name +'_'+ j}}" name="{{element?.field_name +'_'+ j}}" [disabled]="checklistFormGroup?.controls?.[element?.field_name]?.disabled" type="checkbox" [checked]="checklistFormGroup?.controls?.[element?.field_name]?.value ? checklistFormGroup?.controls?.[element?.field_name]?.value.includes(element?.is_options_object ? checkboxData[element?.option_value] : checkboxData) : false" [value]="element?.is_options_object ? checkboxData[element?.option_value] : checkboxData" (change)="onCheckboxValueChange(element?.is_options_object ? checkboxData[element?.option_value] : checkboxData, element?.field_name)" class="h-4 w-4 rounded-lg border-gray-300 text-indigo-600">
                </div>
                <div class="ml-3 text-base">
                  <label for="{{element?.field_name +'_'+ j}}" class="font-medium text-gray-700 cursor-pointer" >{{ element?.is_options_object ? checkboxData[element?.option_label] : checkboxData}}</label>
                </div>
              </div>
            </div>
  
            <!-- Radio -->
            <div class="w-full mb-4" *ngIf="element?.field_type === 'RADIO' && element['showFieldBasedOnDependency']">
              <div class="space-y-4 mt-1 mb-1" *ngFor="let radioData of element?.field_options;let j=index">
                  <div class="flex items-center">
                    <input id="{{element?.field_name +'_'+ j}}" type="radio" [value]="radioData" formControlName="{{element?.formControlName}}" class="h-4 w-4 border-gray-300 text-indigo-600">
                    <label for="{{element?.field_name +'_'+ j}}" class="ml-3 block text-base font-medium text-gray-700 cursor-pointer">{{radioData}}</label>
                  </div>
              </div>
            </div>
            
            <!-- Date Input -->
            <div class="w-full mb-4" *ngIf="element?.field_type === 'DATE' && element['showFieldBasedOnDependency']">
                <div class="mr-4">
                    <input 
                        [matDatepicker]="picker"
                        type="text" 
                        name="{{element?.field_name +'_'+ i}}" 
                        id="{{element?.field_name +'_'+ i}}" 
                        [datePickerFormat]="_utilityService?.dateFormat"
                        class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base cursor-pointer"
                        placeholder="{{element?.field_placeholder}}"
                        formControlName="{{element?.formControlName}}"
                        (click)="picker.open()"
                        [max]="element?.max_value"
                        [min]="element?.min_value"
                    >
                    <mat-datepicker #picker></mat-datepicker>
                </div>
            </div>
  
            <div class="w-full mb-4" *ngIf="element?.field_type === 'DATETIME' && element['showFieldBasedOnDependency']">
              <mat-form-field appearance="fill" class="w-full mt-2">
                  <input matInput 
                      name="{{element?.field_name +'_'+ i}}" 
                      id="{{element?.field_name +'_'+ i}}" 
                      class="form-control cursor-pointer mt-1 mb-1"
                      [ngxMatDatetimePicker]="startDateTimePicker" 
                      (click)="setDate(startDateTimePicker,element?.field_name); startDateTimePicker?.open(); " ngDefaultControl
                      [formControlName]="element?.formControlName"
                      [placeholder]="element?.field_placeholder"
                      [max]="element?.max_value"
                      [min]="element?.min_value"
                      >
                  <ngx-mat-datetime-picker #startDateTimePicker [showSpinners]="true"
                      [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
                      [touchUi]="false" [enableMeridian]="true" [disableMinute]="false">
                      <ngx-mat-datepicker-actions>
                        <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                      </ngx-mat-datepicker-actions>
                  </ngx-mat-datetime-picker>
              </mat-form-field>
            </div>
  
            <!-- File Upload -->
            <div class="w-full mb-4" id="{{'element'+i}}" *ngIf="['VIDEO','MULTI_IMAGE'].includes(element?.field_type) && element['showFieldBasedOnDependency']">
                <div class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base cursor-pointer" [ngClass]="{'pointer-events-none cursor-default': previewForm}">
                  <input type="button" 
                        name="{{element?.field_name +'_'+ i}}" 
                        id="{{element?.field_name +'_'+ i}}"
                        style="background-color: #f2f2f2;"
                        class="border border-gray-700 rounded-sm px-2 py-0.5"  
                        value="Choose file"
                          (click)="openFileUploaderModel($event,element?.field_name,element?.field_name +'_'+ i,element?.field_type)">
                  <span *ngIf="checklistFormGroup?.value[element?.field_name]?.length > 0">({{checklistFormGroup?.value[element?.field_name]?.length}}) files selected</span>
                  <span *ngIf="!checklistFormGroup?.value[element?.field_name]?.length > 0" class="ml-2"> No file chosen</span>
                </div>
            </div>
            <!-- single image -->
            <div class="w-full mb-4" id="{{'element'+i}}" *ngIf="['IMAGE','SIGNATURE','FILE']?.includes(element?.field_type) && element['showFieldBasedOnDependency']">
              <input type="file" 
                    name="{{element?.field_name +'_'+ i}}" 
                    id="{{element?.field_name +'_'+ i}}"
                    accept="{{acceptedFileFormat}}"
                    (change)="onFileUploadValueChange($event,element?.field_name)"
                    [ngClass]="{'pointer-events-none cursor-default': previewForm}"
                    class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base cursor-pointer">
              <a target="_blank" *ngIf="checklistFormGroup?.value[element?.field_name]" [href]="checklistFormGroup?.value[element?.field_name]" class="ml-2 py-2 cursor-pointer text-primary hover:underline">{{'text.view_attached_file' | translate}}</a>
            </div>
  
            <!-- Dropdown Input  -->
            <div class="w-full mb-4" *ngIf="element?.field_type === 'SINGLE_ITEM' && element['showFieldBasedOnDependency']">
              <mat-form-field appearance="fill" class="w-full mt-1 mb-1">
                <mat-select formControlName="{{element?.formControlName}}" [placeholder]="'text.choose_option' | translate">
                  <mat-option [value]="element?.is_options_object ? option[element?.option_value] : option"
                    *ngFor="let option of element?.field_options"> {{ element?.is_options_object ? option[element.option_label] :
                    option }} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- lookup  -->
            <div class="w-full mb-4" *ngIf="element?.field_type === 'LOOKUP' && element['showFieldBasedOnDependency']">
              <div (click)="openLineItemPicker(element?.field_name)" class="py-2 mb-2 cursor-pointer text-primary hover:underline" [ngClass]="{'pointer-events-none cursor-default': previewForm}">{{ previewForm ? ('text.choose.parts' | translate) : ('checklist.choose.parts' | translate)}}</div>
              <div *ngIf="checklistFormGroup?.value[element?.field_name]?.products?.length">
                <table class="border table-auto w-full text-sm mt-3">
                  <thead>
                    <tr>
                      <th class="border-b dark:border-slate-600 font-medium p-4 pl-8 bg-gray-100 text-base text-slate-400 dark:text-slate-200 text-left">{{'text.product_name' | translate}}</th>
                      <th class="border-b dark:border-slate-600 font-medium p-4 pr-8 bg-gray-100 text-base text-slate-400 dark:text-slate-200 text-left">{{'text.quantity' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white dark:bg-slate-800">
                    <tr *ngFor="let product of checklistFormGroup?.value[element?.field_name]?.products;let i=index">
                      <td class="border-b border-slate-100 dark:border-slate-700 p-4 pl-8 text-base text-slate-500 dark:text-slate-400">{{product?.name}}</td>
                      <td class="border-b border-slate-100 dark:border-slate-700 p-4 pr-8 text-base text-slate-500 dark:text-slate-400">{{product?.quantity}} {{product?.uom}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- table  -->
            <div class="w-full mb-4 flex flex-col space-y-2" *ngIf="element?.field_type === 'TABLE' && element['showFieldBasedOnDependency']">
              <div class="w-full max-h-96 overflow-auto zuper-scrollbar">
                <div *ngIf="element?.field_meta?.columns?.length" class="w-full">
                  <table class="border w-full text-sm mt-3">
                    <thead class="w-full">
                      <tr class="w-full">
                        <th class="border border-slate-100 dark:border-slate-600 font-medium px-3 py-3 bg-gray-100 text-base text-slate-400 dark:text-slate-200 text-left w-48" *ngFor="let column of element?.field_meta?.columns">{{column?.field_name}}</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-slate-800 w-full">
                      <tr *ngFor="let data of checklistFormGroup?.value[element?.field_name];let i=index" class="w-full">
                        <td class="border border-slate-100 dark:border-slate-700 text-base text-slate-500 dark:text-slate-400 w-48"  *ngFor="let rowData of data;let j=index">
                          @if (element?.field_meta?.columns[j]?.['field_type'] === 'SINGLE_LINE') {
                            <div class="w-48">
                              <input 
                                    type="text" 
                                    #field_value="ngModel"
                                    name="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                    id="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                    class="block w-full px-3 py-3 text-base"
                                    placeholder="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                    [ngModelOptions]="{standalone: true}"
                                    [ngModel]="checklistFormGroup?.value[element?.field_name][i][j]"
                                    (change)="setTableModel($event,element?.field_name,i,j)"
                                    [required]="element?.field_meta?.columns[j]?.['required']">
                            </div>
                          }
                          @else if (['INTEGER','NUMBER'].includes(element?.field_meta?.columns[j]?.['field_type'])) {
                            <div class="w-48">
                              <input 
                                    type="number" 
                                    #field_value="ngModel"
                                    name="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                    id="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                    class="block w-full px-3 py-3 text-base"
                                    placeholder="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                    [ngModelOptions]="{standalone: true}"
                                    [ngModel]="checklistFormGroup?.value[element?.field_name][i][j]"
                                    (change)="setTableModel($event,element?.field_name,i,j)"
                                    [required]="element?.field_meta?.columns[j]?.['required']">
                                    
                            </div>
                          }
                          @else if (element?.field_meta?.columns[j]?.['field_type'] === 'MULTI_LINE') {
                            <div class="w-48">
                              <input 
                                    type="text" 
                                    #field_value="ngModel"
                                    name="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                    id="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                    class="block w-full px-3 py-3 text-base"
                                    placeholder="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                    [ngModelOptions]="{standalone: true}"
                                    [ngModel]="checklistFormGroup?.value[element?.field_name][i][j]"
                                    (change)="setTableModel($event,element?.field_name,i,j)"
                                    [required]="element?.field_meta?.columns[j]?.['required']">
                                    
                            </div>
                          }
                          @else if (element?.field_meta?.columns[j]?.['field_type'] === 'DATE') {
                            <div class="w-48">
                              <input 
                                  [matDatepicker]="picker"
                                  type="text" 
                                  #field_value="ngModel"
                                  name="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                  id="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                  [datePickerFormat]="_utilityService?.dateFormat"
                                  class="block w-full bg-white shadow-sm px-3 py-3 text-base cursor-pointer"
                                  placeholder="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                  [ngModelOptions]="{standalone: true}"
                                  [ngModel]="checklistFormGroup?.value[element?.field_name][i][j]"
                                  (ngModelChange)="setTableModel($event,element?.field_name,i,j,element?.field_meta?.columns[j]?.['field_type'])"
                                  (click)="picker.open()"
                                  [required]="element?.field_meta?.columns[j]?.['required']"
                              >
                              <mat-datepicker #picker></mat-datepicker>
                            </div>
                          }
                          @else if (element?.field_meta?.columns[j]?.['field_type'] === 'DATETIME') {
                            <div class="w-48">
                              <input 
                                  matInput 
                                  #field_value="ngModel"
                                  name="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                  id="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                  class="block w-full bg-white mx-3 my-3 text-base cursor-pointer"
                                  [ngxMatDatetimePicker]="tableDateTimePicker" 
                                  (click)="tableDateTimePicker?.open()" 
                                  ngDefaultControl
                                  [ngModelOptions]="{standalone: true}"
                                  [ngModel]="checklistFormGroup?.value[element?.field_name][i][j]"
                                  placeholder="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                  [required]="element?.field_meta?.columns[j]?.['required']"
                                  (dateChange)="setTableModel($event?.value,element?.field_name,i,j,element?.field_meta?.columns[j]?.['field_type'])"
                              >
                              <ngx-mat-datetime-picker #tableDateTimePicker [showSpinners]="true"
                                  [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
                                  [touchUi]="false" [enableMeridian]="true" [disableMinute]="false">
                                  <ngx-mat-datepicker-actions>
                                    <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                                  </ngx-mat-datepicker-actions>
                              </ngx-mat-datetime-picker>
                            </div>
                          }
                          @else if (element?.field_meta?.columns[j]?.['field_type'] === 'TIME') {
                            <div class="w-48">
                              <input 
                                [matMenuTriggerFor]="newMenu"
                                type="text" 
                                #field_value="ngModel"
                                name="{{element?.field_meta?.columns[j]?.['field_name']}}" 
                                id="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                [ngModelOptions]="{standalone: true}"
                                [ngModel]="checklistFormGroup?.value[element?.field_name][i][j]"
                                class="block w-full bg-white px-3 py-3 text-base cursor-pointer"
                                placeholder="{{element?.field_meta?.columns[j]?.['field_name']}}"
                                [required]="element?.field_meta?.columns[j]?.['required']"
                              >
                              <mat-menu #newMenu="matMenu">
                                <div class="flex flex-col">
                                    <div class="flex justify-center">
                                    <ngx-mat-timepicker #timePicker (click)="$event.stopPropagation();"
                                    [showSpinners]="true"
                                    [stepHour]="1" [stepMinute]="15"
                                    [showSeconds]="false"
                                    [enableMeridian]="true"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="timePickerModel[element?.field_name + '_' + i + '_' + j]"
                                    (ngModelChange)="setTimeTableModel($event,element?.field_name,i,j)"
                                    >
                                    </ngx-mat-timepicker>
                                    </div>
                                </div>
                              </mat-menu>
                            </div>
                          }
                          @else{
                            {{rowData}}
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              @if ((field_value?.touched || generateFilterForm) && field_value?.errors?.required) {
                <p class="text-red-500 text-base mt-1">{{'text.mandatory.column.error' | translate}}</p>
              }
              @if (element?.field_type === 'TABLE' && element['showFieldBasedOnDependency']) {
                @if(element?.field_meta?.row_config?.restrict_rows !== true ||  (element?.field_meta?.row_config?.restrict_rows === true && checklistFormGroup?.value[element?.field_name]?.length < element?.field_meta?.row_config?.row_count)){
                  <div class="w-full flex justify-end">
                    <button type="button" (click)="addTableRow(element?.field_name)" class="px-2 items-center py-2 border b-1 btn-small border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                      <span class="ti ti-plus mr-2"></span>
                      {{ 'add.text' | translate }}
                    </button>
                  </div>
                }
              }
            </div>
            <p class="text-red-500 text-base mt-1">{{_utilityService.getErrorMessage(checklistFormGroup, element?.field_name,element) | translate}}</p>
            <p *ngIf="element?.show_custom_error" class="text-red-500 text-base mt-1">{{ element?.custom_error_message | translate}}</p>
            <p *ngIf="isFieldDisabled(element)" class="text-red-500 text-base mt-1">{{element?.meta_options?.restrict_status_update?.message ?  element?.meta_options?.restrict_status_update?.message : ('job.checklist.restrict.status.update' | translate)}}</p>
          </ng-container>
        </div>
      </div>
    </div>
    @if(showFooter){
      <div class="absolute inset-x-0 bottom-0 border-t border-gray-200 px-4 py-5 sm:px-6">
        <div class="flex">
          <div class="flex justify-end space-x-3 ml-auto">
            <button type="button" mat-stroked-button (click)="checklistValues.emit('close')"
            class="px-6 items-center py-2 border b-1 btn-small border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
              {{ previewForm ? ('text.close.preview' | translate) : (cancelFormDisplayKey || 'cancel.text') | translate}}
            </button>
            <button
                *ngIf="!previewForm" 
                (click)="onFormSubmitted()"
                [disabled]="isFormDisabled()"
                [ngClass]="{'cursor-not-allowed is-disabled': isFormDisabled()}"
                class="bg-primary btn-small px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base text-white font-medium rounded-md text-white-600 focus:outline-none">
                {{submitFormDisplayKey | translate}}
            </button>
          </div>
        </div>
      </div>
    }
    
  </form>
</div>